import type { ScreenContext } from './types.ts';
import { createMoodChart } from '@/components/mood-chart.ts';
import { createContinueButton } from '@/components/continue-button.ts';
import {
  calculateMetrics,
  getReactionStrengthDescription,
  getResidualEffectDescription,
  getShiftEffectDescription,
} from '@/calculations/metrics.ts';
import { completeSession } from '@/api/operations.ts';

export function renderSummary(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const metrics = state.computedMetrics ?? calculateMetrics(state);

  if (!state.computedMetrics) {
    dispatch({ type: 'SET_COMPUTED_METRICS', payload: metrics });
  }

  if (state.sessionId) {
    completeSession(state.sessionId, {
      reflectionQ1: state.reflections?.q1 ?? null,
      reflectionQ2: state.reflections?.q2 ?? null,
      reflectionQ3: state.reflections?.q3 ?? null,
      reflectionNote: state.reflections?.note ?? null,
      reflectionDurationMs: state.reflections?.durationMs ?? null,
      reactionStrength: metrics.reactionStrength,
      residualEffect: metrics.residualEffect,
      shiftEffect: metrics.shiftEffect,
    }).catch((err) => console.error('Failed to complete session', err));
  }

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Results</p>
        <h2 class="text-2xl font-semibold text-gray-900">Your mood timeline</h2>
      </div>
      <div id="chart-slot"></div>
      <div class="grid grid-cols-1 gap-3" id="stats"></div>
      <div id="action-slot"></div>
    </div>
  `;

  const chart = createMoodChart();
  container.querySelector('#chart-slot')?.appendChild(chart.root);
  chart.render(state.clipTimeline);

  const stats = [
    getReactionStrengthDescription(metrics.reactionStrength),
    getResidualEffectDescription(metrics.residualEffect),
    getShiftEffectDescription(metrics.shiftEffect, state.shiftChoice),
  ];

  const statsContainer = container.querySelector('#stats') as HTMLElement;
  stats.forEach((text) => {
    const card = document.createElement('div');
    card.className = 'border border-gray-200 rounded-lg p-4 bg-gray-50';
    card.textContent = text;
    statsContainer.appendChild(card);
  });

  const btn = createContinueButton('Get guidance');
  container.querySelector('#action-slot')?.appendChild(btn);
  btn.addEventListener('click', () => dispatch({ type: 'NEXT_PHASE' }));
}
